import React from "react";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";

export default function AiModelSelector({ selectedModel, onModelSelect }) {
  const availableAiModels = useSelector(
    (state) => state.workspace.workspaceInfo?.data?.aiModels
  );

  const handleChange = (event) => {
    const modelId = event.target.value;
    const modelData = availableAiModels.find(
      (m) => String(m.id) === String(modelId)
    );
    if (onModelSelect) onModelSelect(modelData);
  };

  if (!availableAiModels?.length)
    return <Typography>No AI models available.</Typography>;

  return (
    <Box sx={{ mt: 3 }}>
      <FormControl fullWidth>
        <InputLabel id="ai-model-select-label">AI Model</InputLabel>
        <Select
          labelId="ai-model-select-label"
          value={selectedModel?.id || ""}
          label="AI Model"
          onChange={handleChange}
        >
          {availableAiModels.map((model) => (
            <MenuItem key={model.id} value={String(model.id)}>
              {model.model.toUpperCase()} ({model.type})
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {selectedModel && (
        <Typography variant="body2" color="text.secondary" mt={1}>
          Selected Model: {selectedModel.model} ✅
        </Typography>
      )}
    </Box>
  );
}
